import { render, staticRenderFns } from "./addReturn.vue?vue&type=template&id=5e2d7bf4&scoped=true"
import script from "./addReturn.vue?vue&type=script&lang=js"
export * from "./addReturn.vue?vue&type=script&lang=js"
import style0 from "./addReturn.vue?vue&type=style&index=0&id=5e2d7bf4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d7bf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e2d7bf4')) {
      api.createRecord('5e2d7bf4', component.options)
    } else {
      api.reload('5e2d7bf4', component.options)
    }
    module.hot.accept("./addReturn.vue?vue&type=template&id=5e2d7bf4&scoped=true", function () {
      api.rerender('5e2d7bf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/logisticsSystem/InternalDelivery/addReturn/addReturn.vue"
export default component.exports